import {
  CalendarBoxIcon
} from "./chunk-BWMX45I7.mjs";
export {
  CalendarBoxIcon
};
